import MojitoCore from 'mojito/core';
import SystemBetsList from './system-bets-list.js';
import PropTypes from 'prop-types';

/**
 * @class SystemBetsList
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * SystemBetsList prop types.
 *
 * @property {boolean} [hasPendingBonus = false] - Flag to indicate if there is any pending bonus or not.
 * @property {boolean} [includeGroupedSingles = true] - Flag to enable or disable grouped single bets.
 * @property {boolean} [enableGroupedSinglesStaking = false] - Flag to indicate if stake input is activated for grouped singles bet.
 * @property {string} [currencyCode] - Currency code used when displaying numbers.
 * @property {Mojito.Services.Betslip.types.Betslip} [betslip = {}] - Betslip.
 * @property {Mojito.Services.Betslip.types.STAKE_GROUP_NAME} [stakeGroup] - Stake group.
 */
const propTypes = {
    includeGroupedSingles: PropTypes.bool,
    enableGroupedSinglesStaking: PropTypes.bool,
    hasPendingBonus: PropTypes.bool,
    currencyCode: PropTypes.string,
    betslip: PropTypes.object,
    stakeGroup: PropTypes.string,
};

const defaultProps = {
    includeGroupedSingles: true,
    enableGroupedSinglesStaking: true,
    hasPendingBonus: false,
    betslip: {},
};

export default MojitoCore.Presentation.UIView(
    'SystemBetsList',
    SystemBetsList,
    propTypes,
    defaultProps
);
